import { config as faConfig } from '@fortawesome/fontawesome-svg-core'

if (process.env.NODE_ENV !== 'development') {
  // disable add css to head for ssr. css is initialized in styled components via GlobalStyle.tsx
  faConfig.autoAddCss = false
}
